import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 12, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.137 0 6.912 1.254l3.763 3.85H0v1.792h10.675l-3.763 3.85L8.137 12 14 6 8.137 0Z", fill: "#246AC1" }));
export default SvgArrow;
